import { relations } from 'drizzle-orm'
import {
  index,
  jsonb,
  pgTable,
  text,
  timestamp,
  uniqueIndex,
} from 'drizzle-orm/pg-core'
import { user } from './auth'

// ========================================
// MODEL STACK TABLE
// ========================================

export const modelStack = pgTable(
  'model_stack',
  {
    id: text('id').primaryKey(),
    userId: text('user_id')
      .notNull()
      .references(() => user.id, { onDelete: 'cascade' }),
    stackId: text('stack_id').notNull(), // The machine-readable identifier (e.g., 'my-stack')
    displayName: text('display_name'), // The human-readable name (e.g., 'My Development Stack'), optional
    agentAssignments: jsonb('agent_assignments').notNull(), // Array of AgentAssignment objects
    contextOptimization: text('context_optimization').default('none'), // 'none' | 'intelligent'
    createdAt: timestamp('created_at').defaultNow().notNull(),
    updatedAt: timestamp('updated_at')
      .defaultNow()
      .$onUpdate(() => new Date())
      .notNull(),
  },
  (table) => [
    index('model_stack_userId_idx').on(table.userId),
    uniqueIndex('model_stack_userId_stackId_uniq').on(
      table.userId,
      table.stackId,
    ),
  ],
)

// ========================================
// RELATIONS
// ========================================

export const modelStackRelations = relations(modelStack, ({ one }) => ({
  user: one(user, {
    fields: [modelStack.userId],
    references: [user.id],
  }),
}))
